import React, { useEffect, useMemo, useState } from 'react'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import { TextArea } from '../../components/Inputs/TextArea'
import Switch from '../../components/Inputs/Switch'
import InputNumber from '../../components/Inputs/InputNumber'
import { useForm } from 'react-hook-form'
import { ISuscriber } from 'safe'
import SelectOfCategories from '../../components/Inputs/SelectOfCategories'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import { ISuscription } from '../Suscriptions/Suscriptions'
import Datepicker from '../../components/Inputs/Datepicker'
import { DateTime } from 'luxon'

const SuscriberForm = ({ onCancel, onSubmit, isLoadingForm, suscriptions, clientName, defaultValues }: { onCancel: () => void; onSubmit: (values: any) => void; isLoadingForm: boolean; suscriptions: ISuscription[]; clientName: string; defaultValues: any }) => {
  const form = useForm({
    defaultValues: {
      client: clientName,
    }
  })

  console.log('defaultValues: ', defaultValues)
  // console.log('suscriptions: ', suscriptions)

  const frequencyOptions = [
    { value: 'daily', text: 'Diario' },
    { value: 'weekly', text: 'Semanal' },
    { value: 'monthly', text: 'Mensual' },
    { value: 'yearly', text: 'Anual' },
  ]

  const ivaTypeOptions = [
    { value: 'GENERAL', text: 'General' },
    { value: 'REDUCED', text: 'Reducido' },
    { value: 'EXEMPT', text: 'Exento' },
  ]

  const onSubmitForm = (values): void => {
    onSubmit({...values, client: selectedClient, duration: 1})
  }

  const [selectedClient, setSelectedClient] = useState(null)

  const options = useMemo(() => {
    return suscriptions.map(suscription => ({ value: suscription.id, text: suscription.description })) || []
  }, [suscriptions])

  const [defaultStartDate, setDefaultStartDate] = useState<string>(
    DateTime.local().setLocale('es').toFormat('d/M/yyyy')
  )

  const [defaultEndDate, setDefaultEndDate] = useState<string>(
    DateTime.local().setLocale('es').toFormat('d/M/yyyy')
  )

  useEffect(() => {
    
    if (defaultValues?.startDate) { 
      const startDate = DateTime.fromFormat(defaultValues.startDate, 'yyyy-MM-dd').setLocale('es').toFormat('d/M/yyyy')
      setDefaultStartDate(startDate)
    }

    if (defaultValues?.endDate) {
      const endDate = DateTime.fromFormat(defaultValues.endDate, 'yyyy-MM-dd').setLocale('es').toFormat('d/M/yyyy')
      setDefaultEndDate(endDate)
    }

  }, [defaultValues])
  

  return (
    <>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-4`}
        onSubmit={(values) => onSubmitForm(values)}
      >
        {/* Header */}
        <div className="col-span-12" style={{ fontWeight: 500, fontSize: '18px' }}>
          { defaultValues ? 'Editar suscriptor' : 'Crear suscriptor' }
        </div>
        
       { !defaultValues && (
         <FormItem
         name="client"
         classes="col-span-6"
         rules={{
           required: 'Debe seleccionar un cliente',
         }}
       >
         <InputText label="Cliente" disabled />
       </FormItem>
       ) }

        <FormItem
          name="subscription"
          classes={!defaultValues ? "col-span-6" : "col-span-12"}
          rules={{
            required: 'Debe seleccionar una suscripción',
          }}
          defaultValue={options.find(option => option.value === defaultValues?.subscriptionId)}
        >
          <SelectOfCategories label="Suscripción" options={ options } />
        </FormItem>

        <FormItem
          name="startDate"
          classes="col-span-6"
          rules={{
            required: 'Debe especificar la fecha de creación del producto',
          }}
          defaultValue={defaultStartDate}

        >
          <Datepicker label="Fecha inicio de la suscripción" />
        </FormItem>

        <FormItem
          name="endDate"
          classes="col-span-6"
          rules={{
            required: 'Debe especificar la fecha de creación del producto',
          }}
          defaultValue={defaultEndDate}
        >
          <Datepicker label="Fecha fin de la suscripción" />
        </FormItem>

        <div
          style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
          className="col-span-12 mt-3"
        ></div>

        {/* Action Buttons */}
        <div className="col-span-12 h-full flex flex-row mt-4">
          <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={onCancel} disabled={isLoadingForm}>
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit" disabled={isLoadingForm} loading={isLoadingForm}>
              Guardar
            </Button>
          </div>
        </div>

      </Form>
    </>
  )
}

export default SuscriberForm
